import PrintReasonDialog from '../../../legacy/React/Components/HeadingAction/PrintReasonDialog';
import { SendEmailDialog } from '../../../legacy/React/Components/HeadingAction/SendInvoiceToEmailDialog';
import { PrintBillModalDialog } from '../../../legacy/React/Components/HeadingAction/PrintBillModalDialog/PrintBillModalDialog';
import { DeleteBillActionDialog } from '../../../legacy/React/Components/HeadingAction/DeleteBillActionDialog';
import RepeatedPrintDialog from '../../../legacy/React/Components/HeadingAction/RepeatedPrintDialog';
import ChargeAndCloseConfirmationDialog from '../../billing/BillCardList/PaymentCard/ChargeAndClose/ChargeAndCloseConfirmationDialog';
import { BillUpdatedReviewDialog } from '../../billing/BillUpdatedReviewDialog';
import { ChangeBillOwnerActionDialog } from '../../../legacy/React/Components/HeadingAction/ChangeBillOwnerActionDialog';
import { ChangeBillAssociatedAccountActionDialog } from '../../../legacy/React/Components/HeadingAction/changeBillAssociatedAccount';
import { LoyaltyMembershipErrorDialog } from '../../bestWestern';
import { SendReminderToEmailDialog } from '../../../legacy/React/Components/HeadingAction/SendReminderToEmailDialog/SendReminderToEmailDialog';

const DialogsHolder = () => (
    <>
        <PrintReasonDialog />
        <RepeatedPrintDialog />
        <SendEmailDialog />
        <SendReminderToEmailDialog />
        <ChangeBillAssociatedAccountActionDialog />
        <ChangeBillOwnerActionDialog />
        <PrintBillModalDialog />
        <BillUpdatedReviewDialog />
        <DeleteBillActionDialog />
        <ChargeAndCloseConfirmationDialog />
        <LoyaltyMembershipErrorDialog />
    </>
);

export default DialogsHolder;
